import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Card,
  Icon,
  Grid,
  IconButton,
  Button,
  TextField,
  Chip
} from '@material-ui/core';
import {
  updateUserApi,
  changeActiveStoreApi,
  getAllTasksFromQueueApi,
  getStoreBrandsApi,
  getStoreProductsApi,
  getQuoteProProductsBySearchCriteriaApi,
} from 'api';
import clsx from 'clsx';
import { storeTypeNameUI } from 'helpers/storeTypeNames';


const userInitialInfo = {
  firstName: '',
  lastName: '',
  email: ''
};

export default function GneralTab() {
  const dispatch = useDispatch();
  const [isUserNameEditing, setIsUserNameEditing] = useState(false);
  const [isUserLastNameEditing, setIsUserLastNameEditing] = useState(false);
  const [userInfo, setUserInfo] = useState(userInitialInfo);
  const { profile = {} } = useSelector((state: IReduxState) => state.user);

  useEffect(() => {
    setUserInfo({firstName: profile.firstName, lastName: profile.lastName, email: profile.email});
  }, [profile]);

  const handleEditUserInfo = () => {
    const userId = profile._id;
    const userProfile = {
      stores: profile.stores,
      firstName: userInfo.firstName ? userInfo.firstName : profile.firstName,
      lastName: userInfo.lastName ? userInfo.lastName : profile.lastName,
      email: profile.email
    };

    updateUserApi({dispatch, userProfile, userId});
  };

  const handleChangeStore = async (store) => {
    await changeActiveStoreApi({ dispatch, storeId: store._id });
    getAllTasksFromQueueApi({dispatch, storeViewCode: store.storeCode});
    getStoreBrandsApi({dispatch});
    getStoreProductsApi({dispatch});

    if (store.quoteProStoreId) {
      getQuoteProProductsBySearchCriteriaApi({
        dispatch,
        sortDirection: 'asc',
        sortField: 'name',
        pageSize: '',
        currentPage: '',
        filterConditions: [
          {
            field: 'status',
            value: '1',
            conditionType: 'eq'
          },
        ],
        searchConditions: []
      });
    }
  };

  return (
    <div className="px-4">
      <Card variant="outlined" elevation={25} className="mt-5 p-7 py-10 pb-7 pt-2">
        <Grid container spacing={3}>
          <Grid item sm={3} xs={12}>
            <h6 className="mb-3 text-gray">First Name:</h6>
          </Grid>
          <Grid className="flex" item sm={9} xs={12}>
            {!isUserNameEditing ?
              <>
                <h5 className="mb-3 text-gray">
                  {profile.firstName}
                </h5>
                <IconButton
                  title="Edit user name"
                  className="pt-0 pl-3"
                  onClick={() => {
                    setIsUserNameEditing(true);
                  }}
                >
                  <Icon>edit</Icon>
                </IconButton>
              </>
              :
              <>
                <TextField
                  name="name"
                  className="w-full max-w-80full"
                  value={userInfo.firstName}
                  onChange={(e) => {
                    setUserInfo({...userInfo, firstName: e.target.value});
                  }}
                />
                <Button
                  onClick={() => {
                    setIsUserNameEditing(false);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  color="primary"
                  onClick={() => {
                    handleEditUserInfo();
                    setIsUserNameEditing(false);
                  }}
                >
                  Save
                </Button>
              </>
            }
          </Grid>
          <Grid item sm={3} xs={12}>
            <h6 className="mb-3 text-gray">Last Name:</h6>
          </Grid>
          <Grid item sm={9} xs={12} className="flex">
            {!isUserLastNameEditing ?
              <>
                <h5 className="mb-3 text-gray">
                  {profile.lastName}
                </h5>
                <IconButton
                  title="Edit user last name"
                  className="pt-0 pl-3"
                  onClick={() => {
                    setIsUserLastNameEditing(true);
                  }}
                >
                  <Icon>edit</Icon>
                </IconButton>
              </>
              :
              <>
                <TextField
                  name="name"
                  className="w-full max-w-80full"
                  value={userInfo.lastName}
                  onChange={(e) => {
                    setUserInfo({...userInfo, lastName: e.target.value});
                  }}
                />
                <Button
                  onClick={() => {
                    setIsUserLastNameEditing(false);
                  }}
                >
                  Cancel
                </Button>
                <Button
                  color="primary"
                  onClick={() => {
                    handleEditUserInfo();
                    setIsUserLastNameEditing(false);
                  }}
                >
                  Save
                </Button>
              </>
            }
          </Grid>
          <Grid item sm={3} xs={12}>
            <h6 className="mb-3 text-gray">Email:</h6>
          </Grid>
          <Grid item sm={9} xs={12}>
            <h5 className="mb-3"> {profile.email}</h5>
          </Grid>
          {profile.stores && profile.stores.map((item, idx) => (
            <>
              <Grid item sm={3} xs={12} className={clsx('flex items-center')}>
                <h6 className="m-0 text-gray">Store: </h6>
              </Grid>
              <Grid item sm={9} xs={12} className={clsx('flex items-center')}>
                <Chip
                  label={storeTypeNameUI[item.storeType]}
                  className="mr-5"
                  size="small"
                  variant="outlined"
                />
                <h5 className="m-0"> {item.storeUrl}</h5>
                <Button
                  disabled={idx === 0}
                  color="primary"
                  className={idx === 0 ? 'text-gray' : ''}
                  onClick={() => handleChangeStore(item)}
                >
                  {idx === 0 ? 'Active' : 'Activate'}
                </Button>
              </Grid>
            </>
          ))}
        </Grid>
      </Card>
      {/* <Grid item lg={6} md={12} sm={12} xs={12}>
        <CardMedia image={logo} className="mt-5">
          <Card  elevation={25} className={clsx("py-19 pb-4", classes.cardBackground)}>
            <div className="text-center mb-2"><Badge color="primary" overlap="circular" badgeContent="" /> <span className="ml-4">Logged In</span></div>
            <h1 className="text-brand font-bold p-2 text-center">{profile.firstName} {profile.lastName}</h1>
            <h4 className="text-brand font-bold text-center">Credit Balance: {pointBalance}</h4>
          </Card>
        </CardMedia>
      </Grid> */}
    </div>
  );
}
